import React from 'react'
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";

const ViewDateGeneric = ({ values, field, moduleText, occupation }) => {
    const { t } = useTranslation();
    return (
        <div
            className={`col-md-${occupation} viewContentGroup`}>
            <label htmlFor="name" className="tit-view-view tit-content-view-view">
                {t(`${moduleText}.synthetic.${field}`)}
            </label>
            <DatePicker
                readOnly
                showYearPicker={false}
                dateFormat="MM-dd-yyyy"
                className="txt-view viewContentTxt border-none"
                selected={values[field] ? new Date(values[field]) : ""}
                name={field}
                id={field}
            />
        </div>
    )
}

export default ViewDateGeneric